module.exports = __webpack_public_path__ + "7d088296/img/search-filter-icon.c4751a52.svg";